import Vue from "vue";


import Page_46eb24d126c282c50bcdfef12b2d63cd from "@/views/100_kmsat45.vue";

import Page_f3dbfabee09ac86d34680333ba3520c8 from "@/views/200_welcome.vue";

import Page_b5894657beb7e3686128d1e3f0ae9cce from "@/views/300_serf.vue";

import Page_38db33b1c977993e882d7869f35b028d from "@/views/400_serf-introduction.vue";

import Page_822e6656085cfa4e39f4a72d08a7f6cd from "@/views/500_hacker-motivations.vue";

import Page_cf76ea7ff020ddfd7acca385eeaf4353 from "@/views/600_most-common-method-exercise.vue";

import Page_dd793a281c432c0739db8223d84c4494 from "@/views/700_phishing-attacks.vue";

import Page_a2dbec3663a7f7ba737993a44b98c866 from "@/views/800_email-red-flags.vue";

import Page_9792dbd18997312f6077e6100ec747bf from "@/views/900_targeted-threats.vue";

import Page_9202c342dbbf86ec8c0f322e6713ab10 from "@/views/1000_targeted-threats-interactive.vue";

import Page_74f4d2bd73752c1314ef9af75141b1b9 from "@/views/1100_insider-threats.vue";

import Page_e4adc8646dea643f1279e24bfff1c35e from "@/views/1200_insider-threats-interactive.vue";

import Page_3be5ecbf89e7e1497157af49f10ea0ab from "@/views/1300_serf-conclusion.vue";

import Page_b1153e9bda9632fb126445bb11ff56df from "@/views/1400_your-role.vue";

import Page_136d600c734f838a1a3a0057a2ffe89c from "@/views/1500_yr-introduction.vue";

import Page_470c40295933188712ba172041c84bf6 from "@/views/1600_guees-that-statistic.vue";

import Page_01f734beed179cba917f07798b308032 from "@/views/1700_cybercrime-strategies.vue";

import Page_e795e84f12475d9e2e3dced9f79deb45 from "@/views/1800_common-digital-attacks.vue";

import Page_f2048e710104ee5f5b1d53d729c20c80 from "@/views/1900_identify-the-attack-1.vue";

import Page_9f584c1c806976fa518d577b1e951e44 from "@/views/2000_identify-the-attack-2.vue";

import Page_379943a24ad1b8a36f9ee4cce066ea69 from "@/views/2100_identify-the-attack-3.vue";

import Page_2b56a514f24f33a82acdaf5362edb278 from "@/views/2200_software-based-attacks.vue";

import Page_34dcb6ecb54031a620d812faea7ff777 from "@/views/2300_internet-based-attacks.vue";

import Page_4aed70e4f36f76045972f31240a3b35b from "@/views/2400_internet-based-attacks-exercise.vue";

import Page_14a7adefbf053d6cad6a513efcdd304a from "@/views/2500_in-person-and-phone-attacks.vue";

import Page_6666332b68c56853197844768b72e4c7 from "@/views/2600_yr-conclusion.vue";

import Page_c37630d124467c853cf06b8b584f7c81 from "@/views/2700_common-threats.vue";

import Page_a633d8f7435bde02450f106919dd2263 from "@/views/2800_ct-introduction.vue";

import Page_04b8583a7a73bc7a66dca1bc4e9d73d9 from "@/views/2900_keeping-information-confidential.vue";

import Page_29479d584b1b3cc6d70fcaa4e411fe28 from "@/views/3000_pretexting.vue";

import Page_b1359d2513939f6aec56fc2eb998cb15 from "@/views/3100_oversharing.vue";

import Page_5950c3d02624f79d710d5b49bba1dee0 from "@/views/3200_too-much-information.vue";

import Page_849517b5b36be5159c1b29620ba3d5de from "@/views/3300_protect-your-password.vue";

import Page_fda242dfb52f1bac0d450e350ad010df from "@/views/3400_credential-harvesting-attack.vue";

import Page_490a799d002edb34b339039e22c39356 from "@/views/3500_humans-and-technology.vue";

import Page_e8effd03dbf413d3f335b68ad4ee4c57 from "@/views/3600_km-two-factor-authentication.vue";

import Page_f0a938d2fe6416d81e94975553f44d5a from "@/views/3700_ct-conclusion.vue";

import Page_79624fb05a77429f993a3aa069fd2df3 from "@/views/3800_quiz-intro.vue";

import Page_564c4e4c63c9878e4ed934de79f75000 from "@/views/3900_quiz.vue";

import Page_04727e31e63a91594f255e5c78b78ba0 from "@/views/4000_congratulations.vue";



import QuizQuestion_894f00f0f35b214a94588d1fb69f0415 from "@/views/quiz/question-11.vue";

import QuizQuestion_895dbfda160360a89aec88819b95b80e from "@/views/quiz/question-04.vue";

import QuizQuestion_949605cec33d59b495385c9103d06447 from "@/views/quiz/question-06.vue";

import QuizQuestion_fc31c440d155926175219ee7cebb6f88 from "@/views/quiz/question-23.vue";

import QuizQuestion_4ef83346984d81a5aa42168e1f799d8d from "@/views/quiz/question-21.vue";

import QuizQuestion_8e3e5b147049dcaf4a9512383d5acc05 from "@/views/quiz/question-27.vue";

import QuizQuestion_fa9bf9425b37cfe051937e82f27e12ca from "@/views/quiz/question-07.vue";

import QuizQuestion_9daf158ba90dfa1da8f29d847a739e24 from "@/views/quiz/question-12.vue";

import QuizQuestion_ec17e9bba9d41cb714e0586c62d38fb1 from "@/views/quiz/question-20.vue";

import QuizQuestion_334fab736aeee4a2a47cbab8e112dd35 from "@/views/quiz/question-28.vue";

import QuizQuestion_b8e3d5cfc8a375f4fc5d8344a51318a2 from "@/views/quiz/question-19.vue";

import QuizQuestion_c078d6265f40a0ee73eb16dea584eb5f from "@/views/quiz/question-24.vue";

import QuizQuestion_23e91792fa5b0e0259b8028f9ead1857 from "@/views/quiz/question-25.vue";

import QuizQuestion_fa2637d908831a866e44cbb93f925558 from "@/views/quiz/question-02.vue";

import QuizQuestion_c07b1132432cb07cf3e1ac5a73117200 from "@/views/quiz/question-22.vue";

import QuizQuestion_317466bc26fd6f6abdb006040ff689be from "@/views/quiz/question-13.vue";

import QuizQuestion_6f416cdde7b233f55c628c58aca99574 from "@/views/quiz/question-17.vue";

import QuizQuestion_8120433bd9ff1fe55c9722f638401a4f from "@/views/quiz/question-08.vue";

import QuizQuestion_935777c69fdfa210b10a7533b6f904bf from "@/views/quiz/question-26.vue";

import QuizQuestion_e2f9b5efa5e8eb12c8e9702290f313f3 from "@/views/quiz/question-15.vue";

import QuizQuestion_556f88e48620c0256cc42cd789066ecb from "@/views/quiz/question-10.vue";

import QuizQuestion_01d2b981957070a24b0753a6f7624592 from "@/views/quiz/question-05.vue";

import QuizQuestion_d82f1c432ec01b97cfdf3d354d06bf39 from "@/views/quiz/question-01.vue";

import QuizQuestion_276a8bce0e9a83c6427261040402ff1a from "@/views/quiz/question-09.vue";

import QuizQuestion_e1e5d8373e9fe7ecec8b357af85c0bc6 from "@/views/quiz/question-29.vue";

import QuizQuestion_477d8c2e95eeaf5c44718e763a93d3de from "@/views/quiz/question-18.vue";

import QuizQuestion_0ed6deb457c4404d97007b1e049f149c from "@/views/quiz/question-16.vue";


import BTB_INTRO from '@/views/BTB_INTRO.vue';
import BTB_OUTRO from '@/views/BTB_OUTRO.vue';


Vue.component("Page_46eb24d126c282c50bcdfef12b2d63cd", Page_46eb24d126c282c50bcdfef12b2d63cd);

Vue.component("Page_f3dbfabee09ac86d34680333ba3520c8", Page_f3dbfabee09ac86d34680333ba3520c8);

Vue.component("Page_b5894657beb7e3686128d1e3f0ae9cce", Page_b5894657beb7e3686128d1e3f0ae9cce);

Vue.component("Page_38db33b1c977993e882d7869f35b028d", Page_38db33b1c977993e882d7869f35b028d);

Vue.component("Page_822e6656085cfa4e39f4a72d08a7f6cd", Page_822e6656085cfa4e39f4a72d08a7f6cd);

Vue.component("Page_cf76ea7ff020ddfd7acca385eeaf4353", Page_cf76ea7ff020ddfd7acca385eeaf4353);

Vue.component("Page_dd793a281c432c0739db8223d84c4494", Page_dd793a281c432c0739db8223d84c4494);

Vue.component("Page_a2dbec3663a7f7ba737993a44b98c866", Page_a2dbec3663a7f7ba737993a44b98c866);

Vue.component("Page_9792dbd18997312f6077e6100ec747bf", Page_9792dbd18997312f6077e6100ec747bf);

Vue.component("Page_9202c342dbbf86ec8c0f322e6713ab10", Page_9202c342dbbf86ec8c0f322e6713ab10);

Vue.component("Page_74f4d2bd73752c1314ef9af75141b1b9", Page_74f4d2bd73752c1314ef9af75141b1b9);

Vue.component("Page_e4adc8646dea643f1279e24bfff1c35e", Page_e4adc8646dea643f1279e24bfff1c35e);

Vue.component("Page_3be5ecbf89e7e1497157af49f10ea0ab", Page_3be5ecbf89e7e1497157af49f10ea0ab);

Vue.component("Page_b1153e9bda9632fb126445bb11ff56df", Page_b1153e9bda9632fb126445bb11ff56df);

Vue.component("Page_136d600c734f838a1a3a0057a2ffe89c", Page_136d600c734f838a1a3a0057a2ffe89c);

Vue.component("Page_470c40295933188712ba172041c84bf6", Page_470c40295933188712ba172041c84bf6);

Vue.component("Page_01f734beed179cba917f07798b308032", Page_01f734beed179cba917f07798b308032);

Vue.component("Page_e795e84f12475d9e2e3dced9f79deb45", Page_e795e84f12475d9e2e3dced9f79deb45);

Vue.component("Page_f2048e710104ee5f5b1d53d729c20c80", Page_f2048e710104ee5f5b1d53d729c20c80);

Vue.component("Page_9f584c1c806976fa518d577b1e951e44", Page_9f584c1c806976fa518d577b1e951e44);

Vue.component("Page_379943a24ad1b8a36f9ee4cce066ea69", Page_379943a24ad1b8a36f9ee4cce066ea69);

Vue.component("Page_2b56a514f24f33a82acdaf5362edb278", Page_2b56a514f24f33a82acdaf5362edb278);

Vue.component("Page_34dcb6ecb54031a620d812faea7ff777", Page_34dcb6ecb54031a620d812faea7ff777);

Vue.component("Page_4aed70e4f36f76045972f31240a3b35b", Page_4aed70e4f36f76045972f31240a3b35b);

Vue.component("Page_14a7adefbf053d6cad6a513efcdd304a", Page_14a7adefbf053d6cad6a513efcdd304a);

Vue.component("Page_6666332b68c56853197844768b72e4c7", Page_6666332b68c56853197844768b72e4c7);

Vue.component("Page_c37630d124467c853cf06b8b584f7c81", Page_c37630d124467c853cf06b8b584f7c81);

Vue.component("Page_a633d8f7435bde02450f106919dd2263", Page_a633d8f7435bde02450f106919dd2263);

Vue.component("Page_04b8583a7a73bc7a66dca1bc4e9d73d9", Page_04b8583a7a73bc7a66dca1bc4e9d73d9);

Vue.component("Page_29479d584b1b3cc6d70fcaa4e411fe28", Page_29479d584b1b3cc6d70fcaa4e411fe28);

Vue.component("Page_b1359d2513939f6aec56fc2eb998cb15", Page_b1359d2513939f6aec56fc2eb998cb15);

Vue.component("Page_5950c3d02624f79d710d5b49bba1dee0", Page_5950c3d02624f79d710d5b49bba1dee0);

Vue.component("Page_849517b5b36be5159c1b29620ba3d5de", Page_849517b5b36be5159c1b29620ba3d5de);

Vue.component("Page_fda242dfb52f1bac0d450e350ad010df", Page_fda242dfb52f1bac0d450e350ad010df);

Vue.component("Page_490a799d002edb34b339039e22c39356", Page_490a799d002edb34b339039e22c39356);

Vue.component("Page_e8effd03dbf413d3f335b68ad4ee4c57", Page_e8effd03dbf413d3f335b68ad4ee4c57);

Vue.component("Page_f0a938d2fe6416d81e94975553f44d5a", Page_f0a938d2fe6416d81e94975553f44d5a);

Vue.component("Page_79624fb05a77429f993a3aa069fd2df3", Page_79624fb05a77429f993a3aa069fd2df3);

Vue.component("Page_564c4e4c63c9878e4ed934de79f75000", Page_564c4e4c63c9878e4ed934de79f75000);

Vue.component("Page_04727e31e63a91594f255e5c78b78ba0", Page_04727e31e63a91594f255e5c78b78ba0);



Vue.component("QuizQuestion_894f00f0f35b214a94588d1fb69f0415", QuizQuestion_894f00f0f35b214a94588d1fb69f0415);

Vue.component("QuizQuestion_895dbfda160360a89aec88819b95b80e", QuizQuestion_895dbfda160360a89aec88819b95b80e);

Vue.component("QuizQuestion_949605cec33d59b495385c9103d06447", QuizQuestion_949605cec33d59b495385c9103d06447);

Vue.component("QuizQuestion_fc31c440d155926175219ee7cebb6f88", QuizQuestion_fc31c440d155926175219ee7cebb6f88);

Vue.component("QuizQuestion_4ef83346984d81a5aa42168e1f799d8d", QuizQuestion_4ef83346984d81a5aa42168e1f799d8d);

Vue.component("QuizQuestion_8e3e5b147049dcaf4a9512383d5acc05", QuizQuestion_8e3e5b147049dcaf4a9512383d5acc05);

Vue.component("QuizQuestion_fa9bf9425b37cfe051937e82f27e12ca", QuizQuestion_fa9bf9425b37cfe051937e82f27e12ca);

Vue.component("QuizQuestion_9daf158ba90dfa1da8f29d847a739e24", QuizQuestion_9daf158ba90dfa1da8f29d847a739e24);

Vue.component("QuizQuestion_ec17e9bba9d41cb714e0586c62d38fb1", QuizQuestion_ec17e9bba9d41cb714e0586c62d38fb1);

Vue.component("QuizQuestion_334fab736aeee4a2a47cbab8e112dd35", QuizQuestion_334fab736aeee4a2a47cbab8e112dd35);

Vue.component("QuizQuestion_b8e3d5cfc8a375f4fc5d8344a51318a2", QuizQuestion_b8e3d5cfc8a375f4fc5d8344a51318a2);

Vue.component("QuizQuestion_c078d6265f40a0ee73eb16dea584eb5f", QuizQuestion_c078d6265f40a0ee73eb16dea584eb5f);

Vue.component("QuizQuestion_23e91792fa5b0e0259b8028f9ead1857", QuizQuestion_23e91792fa5b0e0259b8028f9ead1857);

Vue.component("QuizQuestion_fa2637d908831a866e44cbb93f925558", QuizQuestion_fa2637d908831a866e44cbb93f925558);

Vue.component("QuizQuestion_c07b1132432cb07cf3e1ac5a73117200", QuizQuestion_c07b1132432cb07cf3e1ac5a73117200);

Vue.component("QuizQuestion_317466bc26fd6f6abdb006040ff689be", QuizQuestion_317466bc26fd6f6abdb006040ff689be);

Vue.component("QuizQuestion_6f416cdde7b233f55c628c58aca99574", QuizQuestion_6f416cdde7b233f55c628c58aca99574);

Vue.component("QuizQuestion_8120433bd9ff1fe55c9722f638401a4f", QuizQuestion_8120433bd9ff1fe55c9722f638401a4f);

Vue.component("QuizQuestion_935777c69fdfa210b10a7533b6f904bf", QuizQuestion_935777c69fdfa210b10a7533b6f904bf);

Vue.component("QuizQuestion_e2f9b5efa5e8eb12c8e9702290f313f3", QuizQuestion_e2f9b5efa5e8eb12c8e9702290f313f3);

Vue.component("QuizQuestion_556f88e48620c0256cc42cd789066ecb", QuizQuestion_556f88e48620c0256cc42cd789066ecb);

Vue.component("QuizQuestion_01d2b981957070a24b0753a6f7624592", QuizQuestion_01d2b981957070a24b0753a6f7624592);

Vue.component("QuizQuestion_d82f1c432ec01b97cfdf3d354d06bf39", QuizQuestion_d82f1c432ec01b97cfdf3d354d06bf39);

Vue.component("QuizQuestion_276a8bce0e9a83c6427261040402ff1a", QuizQuestion_276a8bce0e9a83c6427261040402ff1a);

Vue.component("QuizQuestion_e1e5d8373e9fe7ecec8b357af85c0bc6", QuizQuestion_e1e5d8373e9fe7ecec8b357af85c0bc6);

Vue.component("QuizQuestion_477d8c2e95eeaf5c44718e763a93d3de", QuizQuestion_477d8c2e95eeaf5c44718e763a93d3de);

Vue.component("QuizQuestion_0ed6deb457c4404d97007b1e049f149c", QuizQuestion_0ed6deb457c4404d97007b1e049f149c);


Vue.component('BTB_INTRO', BTB_INTRO);
Vue.component('BTB_OUTRO', BTB_OUTRO);
